module.exports = __webpack_public_path__ + "img/serifnew_box25.25227350.jpg";